import React from 'react';
import CtaLink from './CtaLink';
import AnimatedWords from './AnimatedWords';
import useParallax from '../hooks/useParallax';

const ContactHero = () => {
  const parallaxRef = useParallax(0.5);
  
  return (
    <section ref={parallaxRef} className="hero" style={{ '--hero-bg': "url('/images/contact_us_background.webp')" }}>
      <div className="container hero-inner flex w-full items-center lg:items-start">
        <h1 className="text-4xl md:text-6xl lg:text-[79px]">
          <AnimatedWords lines={["Fast, Reliable, and", "Timeless in service."]} />
        </h1>
        <div className='flex flex-col gap-10 lg:gap-0 lg:flex-row items-center lg:justify-between w-full'>
          <div className="hero-content-row">
            <p className="lead text-lg md:text-xl lg:text-2xl">
              <AnimatedWords lines={["Reliable transport. Real-time tracking.", "Tailored logistics for your business."]} />
            </p>
          </div>
          <CtaLink href="#inquiry" primaryText="Start Your Inquiry" ariaLabel="Scroll to inquiry form" />
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
